<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0 v-show="mode == 'transaction_selection'">
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="max">Transferências em espera</h1>
        </v-flex>
        <v-flex xs12>
          <div v-if="responsiblesLoaded == 'not_loaded'">Carregando beneficiários...</div>
          <div v-if="responsiblesLoaded == 'error'">Algo errado. Não foi possível carregar os beneficiários.</div>
          <div v-if="responsiblesLoaded == 'not_authorized'">Não foi possível carregar as beneficiários. Você não foi autorizado.</div>
          <div style="margin-top: 30px;" v-if="responsiblesLoaded == 'empty'">Não existem transferências em espera neste momento.</div>
          <transition name="fade">
            <wire-account-list :config="wireAccountsConfig" v-if="responsiblesLoaded == 'ok' && bankAccountsLoaded == 'ok'" />
          </transition>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid pt-0 mt-0 pb-0 v-if="mode == 'confirmation'">
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="max">Confirmar Transferência</h1>
        </v-flex>
      </v-layout>
    </v-container>
    <confirmation :record="confirmationConfig" v-if="mode == 'confirmation'" class="mt-5">
      <v-btn block dark class="ma-0 btn-style--tertiary mt-2" @click="createWire" :class="{'disable-events': disableCreateWire}" >
        REGISTRAR TRANSFERÊNCIA
      </v-btn>
      <v-btn block dark class="ma-0 btn-style--secondary mt-2" @click="mode = 'transaction_selection'" :class="{'disable-events': disableCreateWire}" >
        VOLTAR
      </v-btn>
    </confirmation>
  </layout>
</template>

<script>
import LeftBarLayout from "./layouts/LeftBarLayout"
import WireAccountsList from "./WireAccountsList"
import WireTransactionList from "./WireTransactionList"
import AdminWireConfirmation from "./AdminWireConfirmation"

export default {
  name: 'AdminWire',
  components: { layout: LeftBarLayout, 'transaction-list': WireTransactionList, 'confirmation': AdminWireConfirmation, 'wire-account-list': WireAccountsList },
  data: () => {
    return {
      wireAccountsConfig: {
        title: '',
        wire_accounts: []
      },
      availableTransactionsConfig: {
        title: 'Transações disponíveis',
        transactions: []
      },
      confirmationConfig: {
        title: 'Informações da transferência',
        transactions: [],
        value: null,
        currency: null,
        fromAccount: null,
        toAccount: null
      },
      currency_config: {
        decimal: ',',
        thousands: '.',
        precision: 4,
      },
      percentage_config: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
      selectedResponsibleId: null,
      responsibles: [],
      bankAccounts: [],
      bankAccountsLoaded: 'not_loaded',
      responsiblesLoaded: 'not_loaded',
      transactionsLoaded: 'not_loaded',
      fromAccountId: null,
      toAccountId: null,
      mode: 'transaction_selection'
    }
  },
  created() {
    this.$root.$on('WIRE_ACCOUNT_ITEM-REMOVE', (id) => {
      this.wireAccountsConfig.wire_accounts.splice(this.wireAccountsConfig.wire_accounts.findIndex(el => el.receiver.id === id), 1)
    })
  },
  mounted() {
    this.$root.authenticationStore.redirectIfNotAuthenticated()

    this.loadResponsibles()
    this.loadBankAccounts()
  },
  computed: {
    fromCurrency() {
      if (!this.selectedOperation) return null
      return this.selectedOperation.split('|')[0]
    },
    toCurrency() {
      if (!this.selectedOperation) return null
      return this.selectedOperation.split('|')[1]
    },
    disableCreateWire() {
      if (this.availableTransactionsConfig.transactions.length === 0) return true

      return false
    },
    fromAccountSelect() {
      return this.accountSelect(this.fromCurrency)
    },
    toAccountSelect() {
      return this.accountSelect(this.toCurrency)
    },
    fromAccountLabel() {
      return `Conta ${this.fromCurrency}`
    },
    toAccountLabel() {
      return `Conta ${this.toCurrency}`
    }
  },
  watch: {
  },
  methods: {
    accountSelect(currency) {
      let bank_accounts = this.bankAccounts.filter( ( record ) => { return record.currency == currency } )
      return bank_accounts.map(o => { return {text: `${o.bank.name} ${o.branch_number} ${o.account_number}`, value: `${o.id}`} })
    },
    loadBankAccounts() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.bankAccounts = response.body.data
          this.wireAccountsConfig.bankAccounts = response.body.data
          this.bankAccountsLoaded = 'ok'
          this.fromAccountId = this.fromAccountSelect[0]
          this.toAccountId = this.toAccountSelect[0]

        } else {
          this.bankAccountsLoaded = 'error'
          console.log('successCallback', response)
          debugger
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.bankAccountsLoaded = 'not_authorized'
        } else {
          this.bankAccountsLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin__user__bank_accounts, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    loadResponsibles() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.responsibles = response.body.data;
          this.wireAccountsConfig.wire_accounts = response.body.data;

          if (this.responsibles.length === 0) {
            this.responsiblesLoaded = 'empty'
          } else {
            this.responsiblesLoaded = 'ok'
          }
        } else {
          this.responsiblesLoaded = 'error'
          console.log('successCallback', response)
          debugger
        }
      }

      let errorCallback = (response) => {
        if (response.status === 401) {
          this.responsiblesLoaded = 'not_authorized'
        } else {
          this.responsiblesLoaded = 'error'
        }
        console.log('errorCallback', response)
        debugger
      }

      this.responsiblesLoaded = 'not_loaded'
      let token = this.$cookies.get('api_token')
      this.$http.get(this.$root.urls.admin__bank_transactions__for_wire, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    createWire() {
      if (this.disableCreateWire) return null

      if (this.mode == 'transaction_selection') {
        this.confirmationConfig.transactions = this.availableTransactionsConfig.transactions
        this.confirmationConfig.currency = this.fromCurrency,
        this.confirmationConfig.fromAccount = this.fromAccountId,
        this.confirmationConfig.toAccount = this.toAccountId

        this.mode = 'confirmation'
        return null
      } else {
        this.mode = 'transaction_selection'
      }

      let successCallback = (response) => {
        this.availableTransactionsConfig.transactions = []

        this.loadResponsibles()
      }

      let errorCallback = (response) => {
        console.log('errorCallback', response)
      }

      const transactionIds = this.availableTransactionsConfig.transactions.map(t => { return t.id })

      const payload = {
        exchange: {
          currency: this.fromCurrency,
          exchange_currency: this.toCurrency,
          from_bank_account_id: this.fromAccountId.value,
          to_bank_account_id: this.toAccountId.value,
          bank_transaction_ids: transactionIds
        }
      }

      let token = this.$cookies.get('api_token')
      this.$http.post(this.$root.urls.admin_exchanges, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    }
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
.disable-events {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/AdminWire.vue